import { render, staticRenderFns } from "./NewsOne.vue?vue&type=template&id=785fcaf9&"
import script from "./NewsOne.vue?vue&type=script&lang=js&"
export * from "./NewsOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports